// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__7LNzt","lostPassword":"LoginForm_lostPassword__1Kh43","signup":"LoginForm_signup__2aD3a","subtitle":"LoginForm_subtitle__1O1_d"};